import Container from 'react-bootstrap/Container';

const CommissionsTab = () => {
  return (
    <Container className="py-4">
    <p>I gladly take commissions, either via photos of the desired subject, or in the flesh. Depending on size and complexity, they can start from as little as £100 unframed. Please visit my gallery page for some examples of recent commissions.</p>

    <p>Please note, I am not a full time artist, so if you wish to discuss a commission - or view some of my work - in person, this would likely be at weekends.</p>

    <p>Please contact me directly if you can't find what you want - I can get prints made at a discount.</p>

    <p>Visit my gallery page for details of original artworks for sale and prices, and contact me if interested in buying.</p>

    <p>I don't restrict myself to conventional painting - I also offer information board illustration services for nature trails, and have been known to paint designs onto cakes, so please get in touch if you would like an edible artwork!</p>

    <p>Visits to my studio are available by appointment if you wish to browse my work.</p>
    </Container>
  );
};

export default CommissionsTab;
